{
    "RestNoContentError": "Ci si aspettava una risposta, ma non è stata data",
    "RestJsonProcessing": "Errore nell'elaborazione di JSON",
    "NAME": "LanguageErrors",
    "UnhandlableError": "Si è verificato un errore non gestibile dal servizio Akixi.",
    "UnknownError": "Si è verificato un errore del server sconosciuto",
    "InvalidCmeId": "ID CME non valido"
}